import { DOCUMENT } from '@angular/common';
import { Injectable, effect, inject } from '@angular/core';

import { TenantScopeService } from './tenant-scope.service';

/** Custom properties the active tenant theme overrides (HLD SM-03). */
const THEME_PROPERTIES = ['--mp-accent', '--mp-accent-dark', '--mp-logo-a', '--mp-logo-b', '--mp-avatar-bg'] as const;

/**
 * Applies the active storefront tenant's brand colors as CSS custom
 * properties on the document element (HLD SM-03). In marketplace scope the
 * inline overrides are removed so the stylesheet defaults in
 * `styles/tokens/_colors.scss` apply. SSR-safe: only the injected DOCUMENT is
 * touched, never `window`.
 */
@Injectable({ providedIn: 'root' })
export class MarketplaceThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly tenantScope = inject(TenantScopeService);

  constructor() {
    effect(() => {
      const tenant = this.tenantScope.tenant();
      const style = this.document.documentElement.style;
      if (tenant === null) {
        for (const property of THEME_PROPERTIES) style.removeProperty(property);
        return;
      }
      const { accent, accentDark, avatarBg } = tenant.theme;
      style.setProperty('--mp-accent', accent);
      style.setProperty('--mp-accent-dark', accentDark);
      style.setProperty('--mp-logo-a', accent);
      style.setProperty('--mp-logo-b', accentDark);
      style.setProperty('--mp-avatar-bg', avatarBg);
    });
  }
}
